import { Components, Theme as MuiTheme } from '@mui/material';
import { ThemeMode } from '../mui';

export const tooltipTheme: Components<MuiTheme> = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === ThemeMode.DARK
            ? theme.palette.common.white
            : theme.palette.common.black,
        color:
          theme.palette.mode === ThemeMode.DARK
            ? theme.palette.text.opposite
            : theme.palette.common.white,
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2),
        fontSize: 16,
        border: `1px solid ${
          theme.palette.mode === ThemeMode.DARK
            ? theme.palette.common.white
            : theme.palette.text.primary
        }`,
      }),
      arrow: ({ theme }) => ({
        color:
          theme.palette.mode === ThemeMode.DARK
            ? theme.palette.common.white
            : theme.palette.common.black,
        '&:before': {
          border: `1px solid ${
            theme.palette.mode === ThemeMode.DARK
              ? theme.palette.common.white
              : theme.palette.text.primary
          }`,
          boxSizing: 'border-box',
        },
      }),
    },
  },
};
